module.exports = __webpack_public_path__ + "img/appended-outer-icon-zoom.65b1161b.svg";